module.exports = __webpack_public_path__ + "static/media/nutritient.22bd7ada.png";